import React, { useEffect, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { FaPhone, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa"; // Importing React Icons
import AOS from "aos";
import { NavLink } from "react-router-dom";

const Contact: React.FC = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);
  const [formData, setFormData] = useState({
    anrede: "",
    titel: "",
    vorname: "",
    nachname: "",
    email: "",
    telefon: "",
    betreff: "",
    nachricht: "",
    agreement: false,
  });
  const { t } = useTranslation("contact");
  const { i18n } = useTranslation();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState<string | null>(null);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const { name, value } = e.target;

    // Handle checkbox specifically
    if (e.target instanceof HTMLInputElement && e.target.type === "checkbox") {
      setFormData({
        ...formData,
        [name]: e.target.checked, // Access the checked property safely
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitMessage(null);

    try {
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          access_key: "da181735-620d-434c-8d59-5baecf7740c1", // Replace with your Web3Forms access key
          ...formData,
        }),
      });

      if (response.ok) {
        setSubmitMessage(t("success"));
        setFormData({
          anrede: "",
          titel: "",
          vorname: "",
          nachname: "",
          email: "",
          telefon: "",
          betreff: "",
          nachricht: "",
          agreement: false,
        });
      } else {
        throw new Error("Failed to send the form");
      }
    } catch (error) {
      setSubmitMessage(t("error"));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="flex flex-col md:flex-row justify-between items-start md:items-center min-h-screen py-28 bg-white px-8 lg:px-20 shadow-lg rounded-md space-y-6 md:space-y-0 md:space-x-12">
      <div className="space-y-4 md:w-1/2" data-aos="fade-up">
        <p className="font-medium text-customRed mb-1 uppercase">
          {t("contact")}
        </p>
        <h2 className="text-3xl font-semibold mb-12 sm:mb-20 text-left uppercase">
          {t("title")}
        </h2>
        <p className="text-text text-lg">{t("text")}</p>
        <p className="text-text text-lg whitespace-pre-line">
          <Trans i18nKey="membershipInfo" ns="contact">
            <a
              href="/Satzung_DALJV_Webseitenversion.pdf"
              className=" text-customRed "
              target="_blank"
              rel="noopener noreferrer"
            >
              DALJV
            </a>
          </Trans>
        </p>
        <div className="space-y-4 mt-6 ">
          <div className="flex items-center text-gray-600 pb-5 pt-5">
            <FaPhone className="mr-4 w-9 h-9 text-customRed" />
            <span className="text-base"> +4915776133163</span>
          </div>
          <div className="flex items-center text-gray-600 pb-5">
            <FaMapMarkerAlt className="mr-4 w-9 h-9 text-customRed" />
            <span>Engelsruhe 20, 65929 Frankfurt am Main</span>
          </div>
          <div className="flex items-center text-gray-600 pb-5">
            <FaEnvelope className="mr-4 w-9 h-9 text-customRed" />
            <span>info@daljv.de</span>
          </div>
        </div>
      </div>

      <form
        className="bg-gray-100 rounded-lg p-6 w-full md:w-1/2 shadow-xl"
        onSubmit={handleSubmit}
        data-aos="fade-up"
      >
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label htmlFor="anrede" className="text-text text-sm">
              {t("salutation")}
            </label>
            <input
              id="anrede"
              name="anrede"
              type="text"
              value={formData.anrede}
              onChange={handleChange}
              className="mt-1 block w-full p-2 border border-dividers rounded-md text-sm focus:ring-red-500 focus:border-red-500"
              required
            />
          </div>
          <div>
            <label htmlFor="titel" className="text-text text-sm">
              {t("title1")}
            </label>
            <input
              id="titel"
              name="titel"
              type="text"
              value={formData.titel}
              onChange={handleChange}
              className="mt-1 block w-full p-2 border border-dividers rounded-md text-sm focus:ring-red-500 focus:border-red-500"
            />
          </div>
          <div>
            <label htmlFor="vorname" className="text-text text-sm">
              {t("name")}
            </label>
            <input
              id="vorname"
              name="vorname"
              type="text"
              value={formData.vorname}
              onChange={handleChange}
              className="mt-1 block w-full p-2 border border-dividers rounded-md text-sm focus:ring-red-500 focus:border-red-500"
              required
            />
          </div>
          <div>
            <label htmlFor="nachname" className="text-text text-sm">
              {t("surname")}
            </label>
            <input
              id="nachname"
              name="nachname"
              type="text"
              value={formData.nachname}
              onChange={handleChange}
              className="mt-1 block w-full p-2 border border-dividers rounded-md text-sm focus:ring-red-500 focus:border-red-500"
              required
            />
          </div>
          <div>
            <label htmlFor="email" className="text-text text-sm">
              {t("email")}
            </label>
            <input
              id="email"
              name="email"
              type="email"
              value={formData.email}
              onChange={handleChange}
              className="mt-1 block w-full p-2 border border-dividers rounded-md text-sm focus:ring-red-500 focus:border-red-500"
              required
            />
          </div>
          <div>
            <label htmlFor="telefon" className="text-text text-sm">
              {t("phone")}
            </label>
            <input
              id="telefon"
              name="telefon"
              type="text"
              inputMode="numeric"
              pattern="^[+]?[\d\s\-]{7,15}$"
              value={formData.telefon}
              onChange={(e) => {
                const value = e.target.value;
                // Allow only numbers, +, -, and space
                if (/^[\d+\-\s]*$/.test(value)) {
                  handleChange(e);
                }
              }}
              className="mt-1 block w-full p-2 border border-dividers rounded-md text-sm focus:ring-red-500 focus:border-red-500"
            />
          </div>
        </div>
        <div className="mt-4">
          <label htmlFor="betreff" className="text-text text-sm">
            {t("reference")}
          </label>
          <input
            id="betreff"
            name="betreff"
            type="text"
            value={formData.betreff}
            onChange={handleChange}
            className="mt-1 block w-full p-2 border border-dividers rounded-md text-sm focus:ring-red-500 focus:border-red-500"
            required
          />
        </div>
        <div className="mt-4">
          <label htmlFor="nachricht" className="text-text text-sm">
            {t("message")}
          </label>
          <textarea
            id="nachricht"
            name="nachricht"
            rows={4}
            value={formData.nachricht}
            onChange={handleChange}
            className="mt-1 block w-full p-2 border border-dividers rounded-md text-sm focus:ring-red-500 focus:border-red-500"
          ></textarea>
        </div>
        <p className="text-sm text-text mt-2">
          <Trans
            i18nKey="find-info"
            ns="contact"
            components={[
              <></>,
              <NavLink
                to={`/${i18n.language}/privacy`}
                onClick={() => window.scrollTo(0, 0)}
                className="text-customRed font-medium inline-block"
              />,
            ]}
          />
        </p>
        <div className="flex justify-center">
          <button
            type="submit"
            className={`mt-6 w-[174px] h-[58px] bg-customRed justify-center text-white py-2 px-4 rounded-[4px] focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 ${
              isSubmitting ? "opacity-50" : ""
            }`}
            disabled={isSubmitting}
          >
            {isSubmitting ? t("sending") : t("submit")}
          </button>

          {submitMessage && (
            <p
              className={`p-4 text-sm ${
                submitMessage.includes("Fehler")
                  ? "text-customRed"
                  : "text-text"
              }`}
            >
              {submitMessage}
            </p>
          )}
        </div>
      </form>
    </div>
  );
};

export default Contact;
